import React from 'react';
import { Helmet } from 'react-helmet-async';

import { getVotingMetadata } from '@client/utils/voting-domain';

interface Props {
  seo?: {
    title?: string;
    description?: string;
  };
  og?: {
    title?: string;
    description?: string;
    imageUrl?: string;
  };
}

export const Head = (props: Props) => {
  const { seo, og } = props;
  const defaults = getVotingMetadata(window.location.hostname);
  const SEO = { ...defaults, ...seo };
  const OG = { ...defaults, ...og };

  return (
    <Helmet>
      <title>{SEO.title}</title>
      <meta name="description" content={SEO.description} />
      <meta property="og:title" content={OG.title} />
      <meta property="og:description" content={OG.description} />
    </Helmet>
  );
};
